import { useState, useEffect } from "react";

const useMobileDevice = (): boolean => {
  const [isMobile, setIsMobile] = useState<boolean>(() => {
    if (typeof navigator === "undefined") return false;
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
      navigator.userAgent
    );
  });

  useEffect(() => {
    const checkMobile = () => {
      if (typeof navigator === "undefined") return;
      setIsMobile(
        /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
          navigator.userAgent
        )
      );
    };

    checkMobile();
  }, []);

  return isMobile;
};

export default useMobileDevice;
